import React from 'react'
import{BsLinkedin} from "react-icons/bs"
const Socials = () => {
  return (
    <div className='Socials'>
        <a href='https://linkedin.com/in/sarvesh-pathak-86812b219' target="blank"><BsLinkedin size={70}/></a>
    </div>
  )
}

export default Socials